import { IUser } from "../../../services/origin/authApi/types";
import { RootState } from "../../store";

export const selectCurrentUser = (state: RootState): IUser | undefined =>
  state.auth.user;

export const selectAccessToken = (state: RootState): string | undefined =>
  state.auth.accessToken;
